import { App } from 'vue';
import 'iconify-icon';
import installComponents from './components';
import { createModalPlugin } from './components/modal';
import { createNotificationPlugin } from './components/notification';
import { createTabsPlugin } from './components/router/tabs-plugin';
import './colors/palette.scss';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

const tabsPlugin = createTabsPlugin();

export function install(app: App) {
  installComponents(app);
  app.use(createModalPlugin());
  app.use(createNotificationPlugin());
  app.use(tabsPlugin);
}

export { tabsPlugin };

export default { install };

export * from './components/all';
